import { gql } from '@apollo/client';

const DOWNLOAD_DUPR_CSV = gql`
  query CsvGenerationForPickleballGroups($id: String!, $tournamentCategory: String, $segment: String, $isManager: Boolean) {
    CsvGenerationForPickleballGroups(id: $id, tournamentCategory: $tournamentCategory, segment: $segment, isManager: $isManager)
  }
`;

export default DOWNLOAD_DUPR_CSV;
